export const SITE = {
    name: "Kore",
    fullName: "Kore Studio Pilates",
    tagline: "Cernobbio · Lago di Como",
    address: "Via Matteotti 14, 22012 Cernobbio (CO)",
    phone: "+39 347 574 0834",
    phoneHref: "tel:+393475740834",
    whatsappDisplay: "+39 347 574 0834",
    whatsappNumber: "393475740834",
    mapsUrl:
        "https://www.google.com/maps/search/?api=1&query=Via+Matteotti+14+22012+Cernobbio+CO",
};

export const DEPOSIT = { label: "€10", lookupKey: "caparra_lezione" };

export const waLink = (text) =>
    `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(text)}`;

export const WA_DEFAULT = waLink(
    "Ciao Kore, vorrei informazioni per prenotare una lezione di Pilates a Cernobbio.",
);

export const IMAGES = {
    hero: "/images/kore-1.jpg",
    lake: "https://images.unsplash.com/photo-1749913808368-dd8d0b378397?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    panorama:
        "https://images.pexels.com/photos/19085371/pexels-photo-19085371.jpeg?auto=compress&cs=tinysrgb&w=1600",
    instructor: "/images/kore-2.jpg",
    teaching: "/images/kore-4.jpg",
    bento: [
        {
            url: "/images/kore-7.jpg",
            title: "Matcha Bar",
            subtitle: "Un tè dopo la lezione, nel nostro angolo benessere",
            span: "col-span-2 row-span-2",
        },
        {
            url: "/images/kore-5.jpg",
            title: "Lo Spogliatoio",
            subtitle: "Doccia walk-in e finiture in pietra naturale",
            span: "col-span-1 row-span-1",
        },
        {
            url: "/images/kore-2.jpg",
            title: "La Sala Macchine",
            subtitle: "Cadillac e small props in rovere e acciaio",
            span: "col-span-1 row-span-1",
        },
        {
            url: "/images/kore-3.jpg",
            title: "Dettagli su Misura",
            subtitle: "Travertino, ottone e luce calda",
            span: "col-span-2 row-span-1",
        },
    ],
};
